import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import {
    selectLocation,
    selectStorageSize,
    selectStorageType,
} from '../store/bookingSlice';

import classes from './JourneyProgress.module.scss';

import router from '../router';
import JourneyStep from './JourneyStep';

function JourneyProgress() {
    const loc = useSelector(selectLocation);
    const storageType = useSelector(selectStorageType);
    const storageSize = useSelector(selectStorageSize);
    const [activeStep, setActiveStep] = useState<number>(1);

    useEffect(() => {
        if (loc) {
            if (!loc) {
                setActiveStep(1);
            }

            if (location.pathname === router.basename + '/booking') {
                setActiveStep(4);
            }

            if (location.pathname.match(/^\/booking-page\/locations\/[^/]+\/?$/)) {
                // If on step 1 'What are you storing for?', go back to /
                if (storageType === null) {
                    setActiveStep(2);
                }

                if (storageType !== null && storageSize !== null) {
                    setActiveStep(3);
                }

                // If on step 2 'How much space do you need?', go back to step 1
                if (storageType !== null && storageSize === null) {
                    setActiveStep(3);
                }

                // If on step 3 'What are you storing?', go back to step 2
                if (storageType !== null && storageSize === 0) {
                    setActiveStep(3);
                }
            }

            if (location.pathname.match(/^\/booking-page\/locations\/[^/]+\/units\/?$/)) {
                setActiveStep(3);
            }

            if (
                location.pathname.match(/^\/booking-page\/locations\/[^/]+\/booking\/?$/)
            ) {
                setActiveStep(4);
            }

            if (
                location.pathname.match(
                    /^\/booking-page\/locations\/[^/]+\/quote-sent\/?$/
                )
            ) {
                setActiveStep(0);
            }
        }
    }, [loc, storageType, storageSize]);

    return (
        <>
            {activeStep > 0 && (
                <div className={`${classes.journey_progress}`}>
                    <JourneyStep to='/' label='Location' active={activeStep} step={1} />
                    <svg
                        width='14'
                        height='28'
                        viewBox='0 0 14 28'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                    >
                        <path d='M1 1L13 14L1 27' stroke='#DEDEDE' strokeWidth='1.2' />
                    </svg>
                    <JourneyStep
                        to={`/locations/${loc?.slug}`}
                        label='Storage Type'
                        active={activeStep}
                        step={2}
                    />
                    <svg
                        width='14'
                        height='28'
                        viewBox='0 0 14 28'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                    >
                        <path d='M1 1L13 14L1 27' stroke='#DEDEDE' strokeWidth='1.2' />
                    </svg>
                    <JourneyStep
                        to={`/locations/${loc?.slug}`}
                        label='Size'
                        active={activeStep}
                        step={3}
                    />
                    <svg
                        width='14'
                        height='28'
                        viewBox='0 0 14 28'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                    >
                        <path d='M1 1L13 14L1 27' stroke='#DEDEDE' strokeWidth='1.2' />
                    </svg>
                    <JourneyStep label='Confirm' active={activeStep} step={4} />
                </div>
            )}
        </>
    );
}

export default JourneyProgress;
